// extracted by mini-css-extract-plugin
export default {"container":"ChoicesContainer_container__NFwSo"};